module.exports = __webpack_public_path__ + "mq.svg?48cd7ba9bfecc363cb4e9dba75236b87";


//////////////////
// WEBPACK FOOTER
// ./src/images/flags/1x1/mq.svg
// module id = 1076
// module chunks = 27